<template>
  <div>
    <v-alert
      v-if="
        parsedConnectionStatus &&
        !loadingConnectionStatus &&
        parsedConnectionStatus.status === 'Connected'
      "
      border="left"
      :color="parsedConnectionStatus.status === 'Connected' ? 'primary' : 'error'"
      dense
      text
      tile
      :type="parsedConnectionStatus.status === 'Connected' ? 'success' : 'error'"
      class="mb-0 text-subtitle-2 py-4"
    >
      <div class="d-flex flex-column flex-md-row align-md-center">
        <span
          v-if="parsedConnectionStatus.status === 'Connected'"
          class="text-caption"
          >Terhubung dengan {{ connection && connection.connection_name }}</span
        >
        <span
          v-else
          class="text-caption"
          >Koneksi {{ connection && connection.connection_name }} bermasalah</span
        >
        <div class="d-flex align-center mt-2 mt-md-0 ml-md-auto">
          <v-btn
            class="ml-md-auto mr-2"
            color="info"
            x-small
            outlined
            @click="checkConnection"
          >
            Cek Koneksi
          </v-btn>
          <v-btn
            color="error"
            x-small
            text
            @click="deleteTrello"
          >
            Hapus
          </v-btn>
        </div>
      </div>
    </v-alert>
    <v-alert
      v-else-if="loadingConnectionStatus"
      border="left"
      dense
      text
      tile
      type="info"
      color="info"
      class="mb-0 text-subtitle-2 py-4"
    >
      <div class="d-flex flex-column flex-md-row align-md-center">
        <span class="text-caption"
          >Sedang mendapatkan status koneksi {{ connectionData.connection_name }}</span
        >
        <v-progress-circular
          indeterminate
          color="info"
          size="12"
          class="ml-4"
        />
      </div>
    </v-alert>
    <v-alert
      v-else
      border="left"
      color="warning"
      dense
      text
      type="warning"
      class="mb-0 text-subtitle-2 py-2 rounded-b-0"
    >
      <div class="d-flex flex-column flex-md-row align-md-center">
        <span class="text-caption"
          >Gagal mendapatkan status koneksi {{ connectionData.connection_name }}</span
        >
        <div class="d-flex align-center mt-2 mt-md-0 ml-md-auto">
          <v-btn
            class="ml-md-auto mr-2"
            color="info"
            x-small
            outlined
            @click="checkConnection"
          >
            Cek Koneksi
          </v-btn>
          <v-btn
            color="error"
            x-small
            text
            @click="deleteTrello"
          >
            Hapus
          </v-btn>
        </div>
      </div>
    </v-alert>
  </div>
</template>
<script>
import { computed, defineComponent, onMounted, watch, ref, inject } from 'vue'

import Vue from 'vue'
import useIntegration from '@/composables/useIntegration'
import { apolloClient } from '@/vue-apollo'
import errorHandling from '@/utils/errorHandling'
import store from '@/store'
import { deleteWorkspaceToken } from '@/graphql/mutations'

export default defineComponent({
  props: {
    connectionData: {
      default: () => {},
      required: true,
      type: Object,
    },
  },
  setup(props, { emit }) {
    const loadingDeleteToken = inject('loadingDeleteToken')
    const connection = computed(() => props.connectionData)
    const { fetchConnectionChekcer, loadingConnectionStatus, connectionStatus } = useIntegration()
    onMounted(() => {
      fetchConnectionChekcer(8, connection.value.connection_name)
    })
    const parsedConnectionStatus = ref(false)
    watch(connectionStatus, () => {
      console.log(connectionStatus.value)
      parsedConnectionStatus.value = {
        ...connectionStatus.value,
        data: connectionStatus.value?.data && JSON.parse(connectionStatus.value.data),
      }
    })
    const checkConnection = () => {
      fetchConnectionChekcer(8, connection.value.connection_name)
    }
    const deleteTrello = () => {
      Vue.$dialog({
        title: 'Hapus token Trello?',
        body: 'Konfirmasi jika anda ingin menghapus token trello.',
      }).then(confirm => {
        if (confirm) {
          loadingDeleteToken.value = true
          apolloClient
            .mutate({
              mutation: deleteWorkspaceToken,
              variables: {
                id: connection.value.id,
                workspace_id: store.getters.getCurrentWorkspaceId,
              },
            })
            .then(() => {
              loadingDeleteToken.value = false
              emit('onDeleteSuccess')
              Vue.notify({
                title: 'Sukses',
                text: 'Berhasil menghapus token trello!',
              })
            })
            .catch(err => {
              loadingDeleteToken.value = false
              errorHandling(err, 'Hapus Integrasi')
            })
        }
      })
    }

    return {
      parsedConnectionStatus,
      loadingConnectionStatus,
      connectionStatus,
      deleteTrello,
      checkConnection,
      connection,
    }
  },
})
</script>
